import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./components/home/Home";
import RedirectLoader from "./components/RedirectLoader/RedirectLoader";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import AmazonDealsPage from "./pages/AmazonDealsPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";

function App() {
  return (
    <Router>
      <div className="flex flex-col max-w-[19200px] overflow-x-hidden overflow-y-auto mx-auto min-h-screen">
        <div className="font-inter w-full relative flex flex-col">
          <div className="px-4 sm:px-8 lg:px-28">
            <Navbar />
          </div>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/amazon-deals" element={<AmazonDealsPage />} />
            <Route path="/price-tracker/:productSlug" element={<ProductDetailsPage />} />
            <Route path="/redirect/:s_id/:p_id" element={<RedirectLoader />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
        <div className="mt-10 md:mt-20">
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
